import React from 'react';
import OrderEditor from '../common/OrderEditor';
import { estimatesAPI, customersAPI } from '../../services/api';

export default function EstimateForm() {
  return (
    <OrderEditor
      title="Estimate"
      api={estimatesAPI}
      basePath="/estimates"
      partyLabel="Customer"
      loadParties={() => customersAPI.list({})}
      idField="customer_id"
      nameField="customer_name"
      dateField="estimate_date"
      secondLabel="Expiration Date"
      secondField="expiration_date"
      statuses={['Draft', 'Sent', 'Accepted', 'Rejected', 'Closed']}
    />
  );
}
